import { getUrlForDev } from 'utils/url';
import { UserType } from 'store/user/user.types';
import { getCallPublicToken } from 'store/calls/calls.slice';
import { useAppDispatch, useAppSelector } from './redux';

// создание ссылки для звонка в новой вкладке с токеном

const useOpenCallWithToken = (userInfo: UserType | null) => {
	const dispatch = useAppDispatch();
	const { language } = useAppSelector((state) => state.lang);
	const host = window.origin;

	const getNewHrefForCall = async (id: string) => {
		const publicTokenData = await dispatch(getCallPublicToken(id)); // @ts-ignore
		const publicToken: { access_token: string; token_type: string } = publicTokenData.payload;
		const hrefWithEnv = getUrlForDev(`${language}/${userInfo?.id}/call?id=${id}&token=${publicToken.access_token}`);
		const newHref = `${host}${hrefWithEnv}`;
		return newHref;
	};

	return { getNewHrefForCall };
};

export default useOpenCallWithToken;
